<template>
	<div class="Authority">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div>
				<CommonBtngroup ref="QuotaBtngroup" :qhide="false"
					:chackbox="userInfo && userInfo.IsSaler === 1?false:true" checktitle="待我审批" @showclick="showclick"
					@hide="hide" @select="select" @reset="reset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<div style="display: inline-block;">
				<!-- -->
				<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<!--   -->
				<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
					:src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" @btnclick="Look"
					:src="require('@/assets/icon/look.png')" :optional="DataListOK.length !== 1">
				</Commonbtn>
			</div>

			<div style="display: inline-block;">
				<!--  -->
				<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="AppExport"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.submit" backgroundColor="#FFF" title="提交" fontSize="14px" @btnclick="Submit"
					opwidth="70px" top="353px" :src="require('@/assets/channel/Submit.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.submit" backgroundColor="#FFF" title="撤回" fontSize="14px" @btnclick="withdraw"
					:src="require('@/assets/channel/withdraw.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.approval&&userInfo && userInfo.IsSaler === 1?false:true" backgroundColor="#FFF"
					title="审批通过" fontSize="14px" @btnclick="Approved" :src="require('@/assets/channel/Approved.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.approval&&userInfo && userInfo.IsSaler === 1?false:true" backgroundColor="#FFF"
					title="驳回" fontSize="14px" @btnclick="Rejectapproval"
					:src="require('@/assets/channel/Rejectapproval.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="审批流程" fontSize="14px" @btnclick="Approvalprocess"
					:src="require('@/assets/channel/Approvalprocess.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.openaccount" backgroundColor="#FFF" title="备案开户" :widthIcon="20" :heightIcon="20"
					fontSize="14px" @btnclick="OpenAccount"
					:src="require('@/assets/channel/DailyWork/OpenAccount.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;" v-if="false">
				<Commondown types="2" backgroundColor="#FFF" fontSize="14px" fontSizeDowns="10px" :datalist="downlist"
					@downs="down" title="更多" :src="require('@/assets/icon/icon-add.png')">
				</Commondown>
			</div>
			<div style="display: inline-block;">
				<Commondown v-if="DowloadList&&DowloadList.length" types="2" backgroundColor="#FFF" fontSize="14px"
					fontSizeDowns="10px" :datalist="DowloadList" @downs="Dowload" title="下载模板"
					:src="require('@/assets/icon/icon-add.png')">
				</Commondown>
			</div>
			<div style="display: inline-block;">
				<Commondown v-if="qx.openaccount" backgroundColor="#FFF" color="#000" fontSize="14px"
					:datalist="LicenseRList" @downs="LicenseRLClick" types="2" title="证照相关">
				</Commondown>
			</div>

			<!-- <a class="Dowload" @click="Dowload">下载二级经销商申请导入模板</a> -->
			<div class="Table">
				<Commontable ref="refTableQuota" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
					width="1000px" colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChange"
						@handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
				</div>
			</div>
			<div class="fileBottomList" v-if="AppCusomerDataBottomList.length > 0">
				<div class="fileBLTab">
					文件
				</div>
				<div class="fileList">
					<div class="fileBottom" v-for="(item , index) of AppCusomerDataBottomList" :key="index">
						<span class="fileName" :title="item.FileName ? item.FileName : item.ImagePath">
							{{ item.FileName ? item.FileName : item.ImagePath}}
						</span>
						<span class="See" @click="See(item)">查看</span>
					</div>
				</div>
			</div>

		</div>
		<DialogFrom width="1150px" :title="TitleEditor" :OKASCAN="true" :dialogVisible="dialogVisibAuthorizationsAdd"
			@cancel="cancelAuthorizationsAdd" @dialogOK="dialogOKAuthorizationsAdd">
			<FromComm :FromArr="FromArrEditor" @AuthorizedDealerChange="AuthorizedDealerChange"
				@invClassChange="invClassChange" @remoteMethod="remoteMethod" @selectChange="authChange">
			</FromComm>
			<template v-if="FromArrEditor[12]&&!FromArrEditor[12].checked">
				<FormUpload :FromUploadSetting="FromUploadSettingImgFile" @getFiles="ImgFileClick" v-if="SeeDisabled">
				</FormUpload>
			</template>
			<FormUpload :FromUploadSetting="FromUploadSettingFile" @getFiles="FileClick" v-if="SeeDisabled">
			</FormUpload>
			<!-- <template v-if="FromArrEditor[12]&&FromArrEditor[12].checked">
				<FormUpload :FromUploadSetting="FromUploadSettingFileRel" @getFiles="RelFileClick" v-if="SeeDisabled">
				</FormUpload>
			</template> -->
			<div class="UploadData">
				<!-- <div class="lable">
          上传照片和文件：
        </div> -->
				<div class="imgOrFile">
					<div class="file" v-for="(item , index) of AppCusomerData" :key="index">
						<span class="fileName">
							{{ item.FileName ? item.FileName : item.ImagePath}}
						</span>
						<span class="Del" @click="Del(index)" v-if="SeeDisabled">删除</span>
						<span class="See" @click="See(item)">查看</span>
					</div>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回原因" :dialogVisible="dialogVisibRejectapproval"
			@cancel="cancelRejectapproval" @dialogOK="dialogOKRejectapproval">
			<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason">
			</el-input>
		</DialogFrom>
		<DialogFrom width="1000px" title="备案开户" :dialogVisible="dialogVisibOpenAccount" @cancel="cancelOpenAccount"
			@dialogOK="dialogOKOpenAccount">
			<FromComm :FromArr="FromArrOpenAccount"></FromComm>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="审批流程" :dialogVisible="dialogVisiblesApprovalprocess"
			@cancel="cancelApprovalprocess" @dialogOK="dialogOKApprovalprocess">
			<div class="from">
				<Commontable ref="refTableQuota" width="1000px" colnum=7 :loadingTable="loadingTableprocess"
					:tableData="ApprovalProcessTableData" :headerData="ApprovalProcessHeaderData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" :title="licenceTitle" :OKASCAN="false" :dialogVisible="LicenseRLookdialogVisibles"
			@cancel="LicenseRLookcancel" @dialogOK="LicenseRLookdialogOK">
			<div class="LicenseRfrom" v-if="lflag">
				<div v-if="Tobereviewed">
					<Commonbtn backgroundColor="#FFF" title="全部审核" margin="0px 20px 20px 0px" fontSize="14px"
						@btnclick="AllReview" :src="require('@/assets/icon/shen.png')">
					</Commonbtn>
					<!-- v-if="license != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="license != null" title="营业执照驳回" margin="0px 20px 20px 10px"
						fontSize="14px" @btnclick="businessLicense" :src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<!--  v-if="permission != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="permission != null" title="医疗器械经营许可证驳回"
						margin="0px 20px 20px 10px" fontSize="14px" @btnclick="medicalEquipment"
						:src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<!-- v-if="record != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="record != null" title="第二类医疗器械备案凭证驳回"
						margin="0px 20px 20px 10px" fontSize="14px" @btnclick="CLLMDFCR"
						:src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<Commondown v-if="RejectStatus" backgroundColor="#FFF" color="#000" fontSize="14px"
						:datalist="LicenseRejected" @downs="LicenseRejectedClick" types="2" title="证照驳回"></Commondown>
				</div>
				<!-- 营业执照 -->
				<License :license="license" @imgShowClick="imgShowClick"></License>
				<!-- 医疗器械经营许可证 -->
				<Permission :permission="permission" @imgShowClick="imgShowClick"></Permission>
				<!-- 第二类医疗器械备案凭证-->
				<Record :record="record" @imgShowClick="imgShowClick"></Record>
				<!-- 开户许可证 -->
				<PicturesType @See="SeeTO" :PicturesTypeData="openaccount" typeTitle="开户许可证"></PicturesType>
				<!-- 经销商信息表 -->
				<PicturesType @See="SeeTO" :PicturesTypeData="cusinfo" typeTitle="经销商信息表"></PicturesType>
				<!-- 业务员授权书 -->
				<PicturesType @See="SeeTO" :PicturesTypeData="salerbusinessauthority" typeTitle="业务员授权书"></PicturesType>
				<!-- 承诺函 -->
				<PicturesType @See="SeeTO" :PicturesTypeData="commitmentletter" typeTitle="承诺函"></PicturesType>
				<!-- 关联申明 -->
				<PicturesType @See="SeeTO" :PicturesTypeData="affiliatestatement" typeTitle="关联申明"></PicturesType>
				<!-- 联系信息 -->
				<InfoturesType @See="SeeTO" :InfoturesTypeData="filecontact" typeTitle="联系信息"></InfoturesType>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回列表" :dialogVisible="rejectdialogVisibles" @cancel="rejectcancel"
			@dialogOK="rejectdialogOK">
			<Commontable @onRowClick="rejectdonRowClick" width="1000px" colnum=7 :tableData="rejectTable"
				:headerData="rejectHeaderData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="rejecthandleCurrentChange" @handleSizeChange="rejecthandleSizeChange"
					:total="rejecttotal"></Pagination>
			</div>
			<div class="detailedCss">{{ detailsTitle }}明细</div>
			<!-- 营业执照驳回列表 -->
			<LicenseRejectList :RejectListProps="BLdetailsTableData" v-if="BLdetailsTableData != null"
				@imgShowClick="imgShowClick"></LicenseRejectList>
			<!-- 医疗器械经营许可证 -->
			<BusinessRejectList :RejectListProps="BusdetailsTableData" v-if="BusdetailsTableData != null"
				@imgShowClick="imgShowClick"></BusinessRejectList>
			<!-- 第二类医疗器械备案凭证 -->
			<ClassIIMedicalRejectList :RejectListProps="RedetailsTableData" v-if="RedetailsTableData != null"
				@imgShowClick="imgShowClick"></ClassIIMedicalRejectList>
			<!-- 承诺函 -->
			<PicTypeRejectList :PicTypeRejectListProps="CommitmentLetterData" v-if="CommitmentLetterData != null"
				@See="SeeTO"></PicTypeRejectList>
			<!-- 开户许可证 -->
			<PicTypeRejectList :PicTypeRejectListProps="openaccountData" v-if="openaccountData != null" @See="SeeTO">
			</PicTypeRejectList>
			<!-- 经销商信息表 -->
			<PicTypeRejectList :PicTypeRejectListProps="cusinfoData" v-if="cusinfoData != null" @See="SeeTO">
			</PicTypeRejectList>
			<!-- 业务员授权书 -->
			<PicTypeRejectList :PicTypeRejectListProps="salerbusinessauthorityData"
				v-if="salerbusinessauthorityData != null" @See="SeeTO"></PicTypeRejectList>
			<!-- 关联申明 -->
			<PicTypeRejectList :PicTypeRejectListProps="affiliatestatementData" v-if="affiliatestatementData != null"
				@See="SeeTO"></PicTypeRejectList>
			<!-- 联系信息 -->
			<infoUserTypeRejectList :InfoturesTypeRejectListData="filecontactData" v-if="filecontactData != null">
			</infoUserTypeRejectList>
		</DialogFrom>
		<DialogFrom width="640px" title="营业执照驳回原因" :dialogVisible="licenseBHdialogVisibles" @cancel="licenseBHcancel"
			@dialogOK="licenseBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonLicense">
			</el-input>
		</DialogFrom>

		<DialogFrom width="640px" title="医疗器械经营许可证驳回原因" :dialogVisible="permissionBHdialogVisibles"
			@cancel="permissionBHcancel" @dialogOK="permissionBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonPermission">
			</el-input>
		</DialogFrom>

		<DialogFrom width="640px" title="第二类医疗器械备案凭证驳回原因" :dialogVisible="recordBHdialogVisibles"
			@cancel="recordBHcancel" @dialogOK="recordBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonRecord">
			</el-input>
		</DialogFrom>
		<!-- 驳回列表中 -->
		<DialogFrom width="1000px" title="驳回原因" :dialogVisible="RejectReasondialogVisibles" @cancel="RejectReasoncancel"
			@dialogOK="RejectReasondialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonPic" style="width: 600px;">
			</el-input>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleApproved" @cancel="cancelApproved"
			@dialogOK="dialogOKApproved" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审批通过这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblewithdraw" @cancel="cancelwithdraw"
			@dialogOK="dialogOKwithdraw" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要撤回这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleSubmit" @cancel="cancelSubmit"
			@dialogOK="dialogOKSubmit" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要提交这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该数据吗？</span>
		</Dialog>
		<Picturepreview :show="showImg" :imgsrc="imgsrc" @hidefn="hidefn"></Picturepreview>
	</div>
</template>

<script>
	import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
	import Commondown from '@/components/common-down.vue'
	import CommonBtngroup from '@/components/commongroup.vue'
	import Picturepreview from '@/components/picturepreview.vue'
	import FormUpload from '@/components/comm-fromUpload.vue'
	import Commonbtn from '@/components/common-btn.vue'
	import CommonbtnUpLoad from '@/components/common-upload.vue'
	import Commontable from '@/components/common-table.vue'
	import Pagination from '@/components/pagination.vue'
	import DialogFrom from '@/components/dialog-from.vue'
	import Dialog from '@/components/dialog.vue'
	import FromArr from './FromData/FromArr'
	import FromArrOpenAccount from './FromData/FromArrOpenAccount'
	import headerData from './headerData/headerData'
	import headerDataEditor from './headerData/headerDataEditor'
	import ApprovalProcessHeaderData from './headerData/ApprovalProcessHeaderData'
	import rejectHeaderData from './headerData/rejectHeaderData'
	import FromArrEditor from './FromData/FromArrEditor'
	import utils from '@/common/utils'
	import License from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/license.vue'
	import Permission from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/permission.vue'
	import Record from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/record.vue'
	import PicturesType from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/PicturesType.vue'
	import InfoturesType from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/InfoturesType.vue'
	import LicenseRejectList from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/license-rejectList.vue'
	import infoUserTypeRejectList from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/infoUserType-rejectList.vue'
	import PicTypeRejectList from '../../../../basicarchivesmanagement/secondarydealerfiles/components/components/PicType-rejectList.vue'
	import {
		APPCustomerList,
		APPCustomerAdd,
		APPCustomerInfo,
		APPCustomerEdit,
		APPCustomerDelete,
		APPCustomerSubmit,
		APPCustomerReject,
		APPCustomerRevoke,
		APPCustomerApproval,
		APPCustomerGetHistory,
		APPCustomerExport,
		HelperApprovalFlowStatus,
		APPCustomerGetAPPCustomerForAddNew,
		APPCustomerUploadImageByEdit,
		HelperOpenAccountStatusByBuyFromHome,
		APPCustomerDoOpenAccount,
		APPCustomerDownloadTemplet,
		OpenAccountGetCommitmentLetter,
		OpenAccountGetOpenAccount,
		OpenAccountGetCusInfo,
		OpenAccountGetAffiliateStatement,
		OpenAccountGetSalerBusinessAuthority,
		OpenAccountGetFileContact,
		GetBOSSNameByInvClass
	} from '@/api/channel'
	import {
		HospitalList,
		InventoryClassList,
		BaOrganizationList,
		CustomerList,
		LicenseGetAllLicense,
		LicenseRejectBusinessLicense,
		LicenseRejectBusinessPermission,
		OpenAccountReject,
		LicenseVerifyLicense,
		LicenseGetRejectLicense,
		LicenseGetBusinessLicense,
		LicenseGetBusinessPermission,
		LicenseGetBusinessRecord,

	} from '@/api/home'
	export default {
		components: {
			FromComm,
			FormUpload,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			CommonbtnUpLoad,
			Dialog,
			Picturepreview,
			Commondown,
			License,
			Permission,
			Record,
			PicturesType,
			InfoturesType,
			LicenseRejectList,
			infoUserTypeRejectList,
			PicTypeRejectList
		},
		props: {},
		data() {
			return {
				dialogVisibAuthorizationsAdd: false,
				dialogVisibAuthorizationsAddHP: false,
				dialogVisiblesApprovalprocess: false,
				licenseBHdialogVisibles: false,
				recordBHdialogVisibles: false,
				permissionBHdialogVisibles: false,
				dialogVisibleApproved: false,
				dialogVisiblewithdraw: false,
				dialogVisibRejectapproval: false,
				dialogVisibOpenAccount: false,
				dialogVisibleSubmit: false,
				dialogVisiblesdrjg: false,
				dialogVisibleVerify: false,
				GCTQORGCYL: false,
				dialogVisibleDel: false,
				LicenseRLookdialogVisibles: false,
				RejectReasondialogVisibles: false,
				SeeDisabled: true,
				chackbox: true,
				showImg: false,
				lflag: false,
				Tobereviewed: false,
				RejectStatus: true,
				rejectdialogVisibles: false,
				loadingTableprocess: true,
				detailsTitle: '',
				RejectReasonPic: "",
				RejectReason: '',
				imgsrc: '',
				InvClass: '',
				invClassRow: '',
				title: '',
				TitleEditor: '',
				ProviderID: '',
				ProviderName: '',
				CusCode: '',
				CusName: '',
				RejectReasonLicense: '',
				RejectReasonPermission: '',
				RejectReasonRecord: '',
				getID: '',
				licenceTitle: '查看有效证照',
				BAMID: null,
				LicenseRList: [{
						title: '查看有效证照',
						flag: true
					},
					{
						title: '查看待审核证照',
						flag: true
					},
					{
						title: '查看历史驳回证照',
						flag: true
					}
				],
				downlist: [{
						title: '提交',
						flag: false
					},
					{
						title: '撤回',
						flag: false
					},
					{
						title: '审批通过',
						flag: false
					},
					{
						title: '驳回',
						flag: false
					},
				],
				DowloadList: [],
				LicenseRejected: [{
						title: '开户许可证',
						flag: true
					},
					{
						title: '经销商信息表',
						flag: true
					},
					{
						title: '业务员授权书',
						flag: true
					},
					{
						title: '承诺函',
						flag: true
					},
					{
						title: '关联申明',
						flag: true
					},
					{
						title: '联系信息',
						flag: true
					},
				],
				rejectHeaderData: [],
				rejectTable: [],
				AppCusomerDataBottomList: [],
				ApprovalProcessHeaderData: [],
				ApprovalProcessTableData: [],
				IDs: [],
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				RejectedIndex: 0,
				RejectpageSize: 10,
				Rejectpageindex: 1,
				rejecttotal: null,
				headerDataEditor: [],
				tableDatadrjg: [],
				DataListOK: [],
				FromArr: [],
				FromArrOpenAccount: [],
				FromArrEditor: [],
				headerData: [],
				tableData: [],
				AppCusomerData: [],
				imgType: ['png', 'jpg', 'jpeg', 'bmp', 'gif'],
				fileType: ['xls', 'xlsx', 'pdf', 'ppt', 'docx', 'doc'],
				FromUploadSettingImgFile: {
					title: "经销商信息表：",
					inputtype: "upload",
					uploadTitle: "上传附件或图片",
					inputflag: true,
					fontSize: 14,
					color: "#333333",
					lableheight: 20,
					X: false,
					placeholder: "请输入",
					width: 300,
					height: 32,
					disabled: false,
					marginLeft: 0,
					marginTop: 20,
					displayVal: "inline-block",
					fontWeightVal: 500,
					multiple: true,
					accept: ".jpg,.png",
					ClickName: 'FileClick',
					backgroundColor: "#fafbfc",
					uploadColor: "rgb(111 113 115)"
				},
				FromUploadSettingFile: {
					title: "经销商引入评估表：",
					inputtype: "upload",
					uploadTitle: "上传附件或图片",
					inputflag: true,
					fontSize: 14,
					color: "#333333",
					lableheight: 20,
					X: false,
					placeholder: "请输入",
					width: 300,
					height: 32,
					disabled: false,
					marginLeft: 620,
					marginTop: -35,
					displayVal: "inline-block",
					fontWeightVal: 500,
					multiple: true,
					accept: "*",
					ClickName: 'FileClick',
					backgroundColor: "#fafbfc",
					uploadColor: "rgb(111 113 115)"
				},
				FromUploadSettingFileRel: {
					title: "与上游经销商关联或合作文件【如有】：",
					inputtype: "upload",
					uploadTitle: "上传附件或图片",
					inputflag: true,
					fontSize: 14,
					color: "#333333",
					lableheight: 20,
					X: false,
					placeholder: "请输入",
					width: 300,
					height: 32,
					disabled: false,
					marginLeft: 0,
					marginTop: 30,
					displayVal: "inline-block",
					fontWeightVal: 500,
					multiple: true,
					accept: "*",
					ClickName: 'FileClick',
					backgroundColor: "#fafbfc",
					uploadColor: "rgb(111 113 115)"
				},
				from: {
					ApplyCode: '',
					CusName: '',
					InvClass: '',
					Status: '',
					CreateTime1: '',
					CreateTime2: '',
					MyApproval: '',
					LicenseStatus: ''

				},
				fromHP: {
					hpCode: "",
					hpName: "",
					HosType: "",
					CreateTime1: "",
					CreateTime2: "",
					authorizeStatus: "",
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
					approval: false, //驳回OR审批通过
					openaccount: false, //备案开户
					License: false
				},
				UnVerifyLicenseCount: null, //待审核证照数量
				ValidLicenseCount: null, //有效证照数量
				RejectLicenseCount: null, //被驳回证照数量
				license: null, //营业执照部分
				permission: null, //医疗器械经营许可证部分
				record: null, //第二类医疗器械备案凭证部分
				openaccount: null,
				cusinfo: null,
				salerbusinessauthority: null,
				commitmentletter: null,
				affiliatestatement: null,
				filecontact: null,
				status: null,
				BLdetailsTableData: null,
				BusdetailsTableData: null,
				RedetailsTableData: null,
				CommitmentLetterData: null,
				openaccountData: null,
				cusinfoData: null,
				salerbusinessauthorityData: null,
				affiliatestatementData: null,
				filecontactData: null,
				enabled: 1,
				cusCodeTo: "",
			}
		},
		created() {
			this.APPCustomerList()
			this.baOrganizationList()
			this.hospitalDataList();
			this.inventoryClassList()
			this.HelperApprovalFlowStatus()
			this.HelperOpenAccountStatusByBuyFromHome()
			this.APPCustomerDownloadTemplet()
		},
		computed: {
			// 获取去年-今年-明年
			Year() {
				let date = new Date()
				let yearStr = `${date.getFullYear() - 1}-${date.getFullYear()}-${date.getFullYear() + 1}`
				let yearArr = [{
						key: date.getFullYear() - 1,
						value: `${date.getFullYear() - 1}年`,
					},
					{
						key: date.getFullYear(),
						value: `${date.getFullYear()}年`,
					},
					{
						key: date.getFullYear() + 1,
						value: `${date.getFullYear() + 1}年`,
					},
				]
				return yearArr
			},
			userInfo() {
				return this.$store.state.MenusData;
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrOpenAccount = JSON.parse(JSON.stringify(FromArrOpenAccount))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataEditor = JSON.parse(JSON.stringify(headerDataEditor))
			this.ApprovalProcessHeaderData = JSON.parse(JSON.stringify(ApprovalProcessHeaderData))
			this.rejectHeaderData = JSON.parse(JSON.stringify(rejectHeaderData))
			this.FromArrEditor[0].options = this.Year
			this.FromArr[2].options = this.Year
		},
		activated() {},
		updated() {},
		methods: {
			down(index) {
				if (index == 0) {
					this.Submit()
				} else if (index == 1) {
					this.withdraw()
				} else if (index == 2) {
					this.Approved()
				} else if (index == 3) {
					this.Rejectapproval()
				}
			},
			//上级经销商的下拉
			async baOrganizationList() {
				let {
					code,
					data
				} = await BaOrganizationList({
					// pageSize: 20,
					// pageIndex: 1,
					CusGrade: 1,
					actived: 1
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CompanyID,
							value: item.CompanyName
						}
						this.FromArrEditor[3].options.push(obj)

					})
				}
			},
			//医院下拉
			async hospitalDataList(hpName = '') {
				let {
					code,
					data
				} = await HospitalList({
					hpName: hpName,
					HosType: '医院',
					pageIndex: 1,
					pageSize: 9999,
				})
				if (code == 0) {
					this.FromArrEditor[11].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID
						}
						this.FromArrEditor[11].options.push(obj)
					})
				}
			},
			AuthorizedDealerChange(e) {
				console.log(e.FromArr);
				this.APPCustomerGetAPPCustomerForAddNew(e.FromArr[1].modelvalue)
			},
			remoteMethod(param) {
				console.log(param);
				if (param.parsign === "PublishremoteMethod") {
					this.hospitalDataList(param.qurey);
				}
				if (param.parsign === "lstParentCodesMethod") {
					this.remoteMethodtows(param.qurey);
				}
				if (param.parsign === "lstBOSSCusCodesMethod") {
					this.remoteMethodBOSSCusCodes(param.qurey);
				}
			},
			ImgFileClick(file) {
				this.APPCustomerUploadImageByEdit(file)
				console.log(file, 'ImgFileClick');
			},
			FileClick(file) {
				this.APPCustomerUploadImageByEdit(file)
				console.log(file, 'FileClick');
			},
			RelFileClick(file) {
				this.APPCustomerUploadImageByEdit(file, 'rel'); //  与上游经销商关联或合作文件
				console.log(file, 'FileClick');
			},
			// 列表
			async APPCustomerList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPCustomerList({
					ApplyCode: this.from.ApplyCode,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					Year: this.from.Year,
					LicenseStatus: this.from.LicenseStatus,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data

				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			invClassChange(e) {
				this.getBOSSName();
			},
			async getBOSSName() {
				let CusCode = this.FromArrEditor[0].modelvalue;
				let InvClassList = this.FromArrEditor[2].modelvalue;
				if (CusCode && InvClassList && InvClassList.length > 0) {
					let InvClass = Array.isArray(InvClassList) ? InvClassList.join(',') : InvClassList;
					let { code, data, message } = await GetBOSSNameByInvClass({
						CusCode: CusCode,
						InvClass: InvClass
					});
					if (code == 0) {
						if (data) {
							this.FromArrEditor[14].modelvalue = data;
							this.FromArrEditor[14].disabled = true;
						} else {
							if (this.TitleEditor !== '查看') {
								this.FromArrEditor[14].disabled = false;
							}
						}
					} else {
						this.$message({
							type: 'error',
							message: message
						});
						if (this.TitleEditor !== '查看') {
							this.FromArrEditor[14].disabled = false;
						}
					}
				} else {
					if (this.TitleEditor !== '查看') {
						this.FromArrEditor[14].disabled = false;
					}
				}
			},
			// 新增带出的数据
			async APPCustomerGetAPPCustomerForAddNew(CusName) {
				let {
					code,
					data,
					message
				} = await APPCustomerGetAPPCustomerForAddNew({
					CusName: CusName
				})
				if (code == 0) {
					if (data != null) {
						this.FromArrEditor[0].modelvalue = data.CusCode
						this.FromArrEditor[2].modelvalue = data.InvClassList
						this.FromArrEditor[4].checked = data.BuyFromHome == 0 ? false : true
						this.FromArrEditor[5].checked = false // data.NeedBossApproval == 0 ? false : true
						this.FromArrEditor[6].modelvalue = data.LinkMan
						this.FromArrEditor[7].modelvalue = data.LinkPhone
						this.FromArrEditor[6].modelvalue = data.Mobile
						this.FromArrEditor[7].modelvalue = data.Email
						
						this.getBOSSName();
					} else {
						this.FromArrEditor.forEach((item, index) => {
							if (index == 4 || index == 5) {
								item.checked = false
							} else if (index != 1) {
								item.modelvalue = ''
							}

						})
					}
				} else {
					this.$message.warning(message)
				}
			},
			// 新增
			async APPCustomerAdd() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let ImageNames = [] //类型：图片
				let AttachmentNames = [] //类型：文件
				//上传后的图片分类
				this.AppCusomerData.forEach((item, index) => {
					//console.log(this.imgType.includes(item.Extension));
					// if (this.imgType.includes(item.Extension)) {
					// 	ImageNames.push(item.FileName)
					// } else if (this.fileType.includes(item.Extension)) {
					// 	AttachmentNames.push(item.FileName)
					// }
					if (item.t) {
						ImageNames.push(item.FileName)
					} else {
						AttachmentNames.push(item.FileName)
					}
				})
				console.log(ImageNames, AttachmentNames);
				let {
					code,
					message,
					data
				} = await APPCustomerAdd({
					CusCode: this.FromArrEditor[0].modelvalue,
					CusName: this.FromArrEditor[1].modelvalue,
					InvClassList: this.FromArrEditor[2].modelvalue,
					CompanyID: this.FromArrEditor[3].modelvalue ? this.FromArrEditor[3].modelvalue.join(',') :
						'',
					//BuyFromHome: this.FromArrEditor[4].checked ? 1 : 0,
					NeedBossApproval: 0,
					FileLinkMan: this.FromArrEditor[6].modelvalue,
					FileLinkTel: this.FromArrEditor[7].modelvalue,
					FileReceiveAddress: this.FromArrEditor[9].modelvalue,
					Remark: this.FromArrEditor[10].modelvalue,
					FileEMail: this.FromArrEditor[8].modelvalue,
					ImageNames: ImageNames,
					AttachmentNames: AttachmentNames,
					lstHospitalIDs: this.FromArrEditor[11].modelvalue,
					IsProvider: this.FromArrEditor[12].checked ? 1 : 0,
					lstParentCodes: this.FromArrEditor[13].modelvalue,
					BOSSName: this.FromArrEditor[14].modelvalue,
					lstBOSSCusCodes: this.FromArrEditor[15] ? this.FromArrEditor[15].modelvalue : [],
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibAuthorizationsAdd = false
					this.APPCustomerList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 修改二级经销商申请
			async APPCustomerEdit() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let ImageNames = [] //类型：图片
				let AttachmentNames = [] //类型：文件
				//上传后的图片分类
				console.log(this.AppCusomerData, ' this.AppCusomerData');
				this.AppCusomerData.forEach((item, index) => {
					// if (item.ImageType) {
					// 	// if (item.ImageType == 6) {
					// 	// 	ImageNames.push(item.ImagePath)
					// 	// 	console.log(ImageNames, 'ImageNames');
					// 	// } else if (item.ImageType == 7) {
					// 	// 	AttachmentNames.push(item.ImagePath)
					// 	// }
					// 	if (item.ImagePath.includes('jpg') || item.ImagePath.includes('png') || item.ImagePath
					// 		.includes(
					// 			'gif')) {
					// 		ImageNames.push(item.ImagePath)
					// 	} else {
					// 		AttachmentNames.push(item.ImagePath)
					// 	}
					// } else {
					// 	if (this.imgType.includes(item.Extension)) {
					// 		ImageNames.push(item.FileName)
					// 	} else if (this.fileType.includes(item.Extension)) {
					// 		AttachmentNames.push(item.FileName)
					// 	}
					// }

					if (item.t) {
						ImageNames.push(item.FileName || item.ImagePath)
					} else {
						AttachmentNames.push(item.FileName || item.ImagePath)
					}
				})
				console.log(ImageNames, '图片');
				console.log(AttachmentNames, '文件');

				let {
					code,
					message,
					data
				} = await APPCustomerEdit({
					ID: this.ID,
					CusCode: this.FromArrEditor[0].modelvalue,
					CusName: this.FromArrEditor[1].modelvalue,
					InvClassList: this.FromArrEditor[2].modelvalue,
					CompanyID: this.FromArrEditor[3].modelvalue ? this.FromArrEditor[3].modelvalue.join(',') :
						'',
					//BuyFromHome: this.FromArrEditor[4].checked ? 1 : 0,
					NeedBossApproval: 0,
					FileLinkMan: this.FromArrEditor[6].modelvalue,
					FileLinkTel: this.FromArrEditor[7].modelvalue,
					FileReceiveAddress: this.FromArrEditor[9].modelvalue,
					Remark: this.FromArrEditor[10].modelvalue,
					FileEMail: this.FromArrEditor[8].modelvalue,
					ImageNames: ImageNames,
					AttachmentNames: AttachmentNames,
					lstHospitalIDs: this.FromArrEditor[11].modelvalue,
					IsProvider: this.FromArrEditor[12].checked ? 1 : 0,
					lstParentCodes: this.FromArrEditor[13].modelvalue,
					BOSSName: this.FromArrEditor[14].modelvalue,
					lstBOSSCusCodes: this.FromArrEditor[15] ? this.FromArrEditor[15].modelvalue : [],
				})

				if (code == 0) {
					this.dialogVisibAuthorizationsAdd = false
					this.APPCustomerList()
					this.$message.success(message)
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 上传照片和文件
			async APPCustomerUploadImageByEdit(file, t) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '正在上传...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formdata = new FormData()
					for (var i = 0; i < file.length; i++) {
						formdata.append("files", file[i]);
					}
					let {
						data,
						code,
						message
					} = await APPCustomerUploadImageByEdit(formdata)
					if (code == 0) {
						this.$message({
							type: 'success',
							message: message
						});
						data.forEach((item, index) => {
							if (t) {
								item.t = t;
							}
							this.AppCusomerData.push(item)
						})
						loading.close();
						return
					} else if (code == 101) {
						this.$message({
							type: 'warning',
							message: message
						});
						loading.close();
						return
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = data
						this.title = "上传结果"
						this.$message({
							type: 'error',
							message: message
						});
						loading.close();
					}
				}
			},
			// 查看图片
			See(item) {
				if (this.TitleEditor == '新增二级经销商申请') {
					console.log('其他1');
					if (item.Extension == 'jpg' || item.Extension == 'png' || item.Extension == 'gif') {
						this.showImg = true
						this.imgsrc = item.FileUrl
					} else {
						window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
					}
				} else if (this.TitleEditor == '修改二级经销商申请') {
					console.log('其他2');
					if (item.ImageType) {
						// if (item.ImageType == 6) {
						// 	this.showImg = true
						// 	this.imgsrc = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						// } else if (item.ImageType == 7) {
						// 	window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
						// }
						if (item.ImagePath.includes('jpg') || item.ImagePath.includes('png') || item.ImagePath.includes(
								'gif')) {
							this.showImg = true
							this.imgsrc = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						} else {
							window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
						}
					} else {
						if (item.Extension == 'jpg' || item.Extension == 'png' || item.Extension == 'gif') {
							this.showImg = true
							this.imgsrc = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						} else {
							window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
							// window.location.href = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						}
					}

				} else {
					console.log('其他');
					if (item.ImageType) {
						if (item.ImagePath.includes('jpg') || item.ImagePath.includes('png') || item.ImagePath.includes(
								'gif')) {
							this.showImg = true
							this.imgsrc = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						} else {
							window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
						}
						// if (item.ImageType == 6) {
						// 	this.showImg = true
						// 	this.imgsrc = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						// } else if (item.ImageType == 7) {
						// 	window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
						// }
					} else {
						if (item.Extension == 'jpg' || item.Extension == 'png' || item.Extension == 'gif') {
							this.showImg = true
							this.imgsrc = item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl
						} else {
							window.open(item.ImageUrlPath ? item.ImageUrlPath : item.FileUrl, '_blank')
						}
					}
				}


			},
			// 删除图片
			Del(index) {
				this.AppCusomerData.splice(index, 1)
			},
			hidefn() {
				this.showImg = false
			},
			// 详情
			async APPCustomerInfo(type) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await APPCustomerInfo({
					ID: this.ID
				})
				if (code == 0) {
					if (type == "See") {
						this.AppCusomerDataBottomList = data.lstImages
					} else if (type == "Edit") {
						this.remoteMethodtows();
						this.remoteMethodBOSSCusCodes();
						this.FromArrEditor[0].modelvalue = data.CusCode
						this.FromArrEditor[1].modelvalue = data.CusName
						this.FromArrEditor[2].modelvalue = data.InvClassList
						this.FromArrEditor[3].modelvalue = data.CompanyID ? data.CompanyID.split(',') : null
						this.FromArrEditor[4].checked = data.BuyFromHome == 1 ? true : false
						this.FromArrEditor[5].checked = false // data.NeedBossApproval == 1 ? true : false
						this.FromArrEditor[6].modelvalue = data.FileLinkMan
						this.FromArrEditor[7].modelvalue = data.FileLinkTel
						this.FromArrEditor[9].modelvalue = data.FileReceiveAddress
						this.FromArrEditor[8].modelvalue = data.FileEMail
						this.FromArrEditor[10].modelvalue = data.Remark
						this.FromArrEditor[11].modelvalue = data.lstHospitalIDs;
						this.FromArrEditor[12].checked = data.IsProvider ? true : false;
						this.FromArrEditor[12].disabled = true;
						this.FromArrEditor[13].modelvalue = data.lstParentCodes;
						this.FromArrEditor[14].modelvalue = data.BOSSName;
						let arr = [];

						if (data.lstParentCodes) {
							data.lstParentCodes.map((item, index) => {
								arr.push({
									label: data.lstParentNames[index],
									value: item,
								})
							})
						}

						this.FromArrEditor[13].options = arr;

						if (this.FromArrEditor[15]) {
							this.FromArrEditor[15].modelvalue = data.lstBOSSCusCodes || [];
							let arrBoss = [];
							if (data.lstBOSSCusCodes) {
								data.lstBOSSCusCodes.map((item, index) => {
									arrBoss.push({
										label: (data.lstBOSSCusNames && data.lstBOSSCusNames[index]) ?
											data.lstBOSSCusNames[index] : item,
										value: item,
									})
								})
							}
							this.FromArrEditor[15].options = arrBoss;
						}

						this.authChange();
						this.getBOSSName();

						if (data.lstImages.length) {
							data.lstImages.forEach((item, index) => {
								item.t = 'rel';
								this.AppCusomerData.push(item);
							})
						}

						if (data.AttachmentNames && data.AttachmentNames.length) {
							data.AttachmentNames.forEach((item, index) => {
								this.AppCusomerData.push(item);
							})
						}

						this.dialogVisibAuthorizationsAdd = true
					} else if (type == "Look") {
						this.remoteMethodtows();
						this.remoteMethodBOSSCusCodes();
						this.FromArrEditor[0].modelvalue = data.CusCode
						this.FromArrEditor[1].modelvalue = data.CusName
						this.FromArrEditor[2].modelvalue = data.InvClassList
						this.FromArrEditor[3].modelvalue = data.CompanyID ? data.CompanyID.split(',') : null
						this.FromArrEditor[4].checked = data.BuyFromHome == 1 ? true : false
						this.FromArrEditor[5].checked = false // data.NeedBossApproval == 1 ? true : false
						this.FromArrEditor[6].modelvalue = data.FileLinkMan
						this.FromArrEditor[7].modelvalue = data.FileLinkTel
						this.FromArrEditor[9].modelvalue = data.FileReceiveAddress
						this.FromArrEditor[8].modelvalue = data.FileEMail
						this.FromArrEditor[10].modelvalue = data.Remark
						this.FromArrEditor[11].modelvalue = data.lstHospitalIDs
						this.FromArrEditor[12].checked = data.IsProvider ? true : false;
						this.FromArrEditor[12].disabled = true;
						this.FromArrEditor[13].modelvalue = data.lstParentCodes;
						this.FromArrEditor[14].modelvalue = data.BOSSName;
						let arr = [];
						if (data.lstParentCodes) {
							data.lstParentCodes.map((item, index) => {
								arr.push({
									label: data.lstParentNames[index],
									value: item,
								})
							})
						}
						this.FromArrEditor[13].options = arr;

						if (this.FromArrEditor[15]) {
							this.FromArrEditor[15].modelvalue = data.lstBOSSCusCodes || [];
							let arrBoss = [];
							if (data.lstBOSSCusCodes) {
								data.lstBOSSCusCodes.map((item, index) => {
									arrBoss.push({
										label: (data.lstBOSSCusNames && data.lstBOSSCusNames[index]) ?
											data.lstBOSSCusNames[index] : item,
										value: item,
									})
								})
							}
							this.FromArrEditor[15].options = arrBoss;
						}

						console.log(this.FromArrEditor[13].options);
						this.authChange();

						if (data.lstImages.length) {
							data.lstImages.forEach((item, index) => {
								item.t = 'rel';
								this.AppCusomerData.push(item);
							})
						}

						if (data.AttachmentNames && data.AttachmentNames.length) {
							data.AttachmentNames.forEach((item, index) => {
								this.AppCusomerData.push(item);
							})
						}
						this.dialogVisibAuthorizationsAdd = true
					}

				} else {
					this.$message.error("请选择操作的数据！")
				}
				loading.close()
			},
			Look() {
				if (this.DataListOK.length === 1) {
					this.ID = this.DataListOK[0].ID;
				}
				if (!this.ID) {
					this.$message.error('请先选择数据');
					return;
				}
				this.TitleEditor = '查看'
				this.APPCustomerInfo("Look")
			},
			// 删除
			async APPCustomerDelete() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerDelete({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleDel = false
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.dialogVisibleDel = false
					this.dialogVisiblesdrjg = true
					this.title = '删除结果'
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 提交
			async APPCustomerSubmit() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerSubmit({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleSubmit = false
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.dialogVisibleSubmit = false
					this.dialogVisiblesdrjg = true
					this.title = '提交结果'
					this.tableDatadrjg = data
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 撤回
			async APPCustomerRevoke(val) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerRevoke({
					IDs: IDs,
					Reason: val
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblewithdraw = false
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisiblewithdraw = false
					this.title = '撤回结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 驳回
			async APPCustomerReject() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerReject({
					IDs: IDs,
					RejectReason: this.RejectReason
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibRejectapproval = false
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibRejectapproval = false
					this.title = '驳回结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 驳回列表
			async licenseGetRejectLicense() {
				let {
					code,
					data,
					message
				} = await LicenseGetRejectLicense({
					cusCode: this.cusCodeTo,
					cusType: "经销商",
					pageSize: this.RejectpageSize,
					pageIndex: this.Rejectpageindex
				})
				if (code == 0) {
					this.rejecttotal = data.Count
					this.rejectTable = data.data
				}
			},
			// 营业执照驳回明细接口
			async licenseGetBusinessLicense() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessLicense({
					ID: this.getID
				})
				if (code == 0) {
					this.BusdetailsTableData = null
					this.RedetailsTableData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.openaccountData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.BLdetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 医疗器械经营许可证驳回明细接口
			async licenseGetBusinessPermission() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessPermission({
					ID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.CommitmentLetterData = null
					this.openaccountData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.BusdetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 第二类医疗器械备案凭证驳回明细接口
			async licenseGetBusinessRecord() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessRecord({
					ID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.BusdetailsTableData = null
					this.CommitmentLetterData = null
					this.openaccountData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.RedetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表承诺书
			async OpenAccountGetCommitmentLetter() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetCommitmentLetter({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.CommitmentLetterData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表开户许可证
			async OpenAccountGetOpenAccount() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetOpenAccount({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = data
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表经销商信息表
			async OpenAccountGetCusInfo() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetCusInfo({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = data
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表关联申明
			async OpenAccountGetAffiliateStatement() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetAffiliateStatement({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表业务员授权书
			async OpenAccountGetSalerBusinessAuthority() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetSalerBusinessAuthority({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = data
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表联系信息
			async OpenAccountGetFileContact() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetFileContact({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.filecontactData = data
					this.CommitmentLetterData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},

			LicenseRLClick(index) {
				if (index == 0) {
					// this.UnVerifyLicenseCount = val.UnVerifyLicenseCount //待审核证照数量
					// this.ValidLicenseCount = val.ValidLicenseCount //有效证照数量
					// this.RejectLicenseCount = val.RejectLicenseCount //被驳回证照数量
					console.log(this.ID);
					if (this.ID) {
						if (this.ValidLicenseCount > 0) {
							this.LicenseRLookdialogVisibles = true
							this.status = null
							this.enabled = 1
							this.licenseGetAllLicense()
							this.Tobereviewed = false
							return
						}
						this.$message({
							type: "warning",
							message: "没有所查看的有效证照"
						})

						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})

					//console.log(this.UnVerifyLicenseCount, this.ValidLicenseCount, this.RejectLicenseCount);
				}
				if (index == 1) {
					if (this.ID) {
						if (this.UnVerifyLicenseCount > 0) {
							this.status = 0
							this.enabled = 0
							this.licenceTitle = "审核有效证照"
							this.licenseGetAllLicense()
							this.LicenseRLookdialogVisibles = true
							this.Tobereviewed = true
							return
						}
						this.$message({
							type: "warning",
							message: "没有审核有效证照"
						})
						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})
				}
				if (index == 2) {
					if (this.ID) {
						if (this.RejectLicenseCount > 0) {
							this.rejectdialogVisibles = true
							this.licenseGetRejectLicense()
							return
						}
						this.$message({
							type: "warning",
							message: "没有驳回相关数据"
						})
						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})

				}
			},
			// 查看各种状态证照
			async licenseGetAllLicense() {
				let {
					data,
					code,
					message
				} = await LicenseGetAllLicense({
					cusCode: this.cusCodeTo,
					cusType: "经销商",
					status: this.status,
					enabled: this.enabled
				})
				if (code == 0) {
					this.lflag = true
					this.license = data.license //营业执照部分
					this.permission = data.permission //医疗器械经营许可证部分
					this.record = data.record //第二类医疗器械备案凭证部分
					if (data.openaccount || data.cusinfo ||
						data.salerbusinessauthority || data.commitmentletter ||
						data.affiliatestatement || data.filecontact
					) {
						this.RejectStatus = true
					} else {
						this.RejectStatus = false
					}
					if (data.openaccount == null) {
						this.LicenseRejected[0].flag = false
					} else {
						this.LicenseRejected[0].flag = true
					}
					if (data.cusinfo == null) {
						this.LicenseRejected[1].flag = false
					} else {
						this.LicenseRejected[1].flag = true
					}
					if (data.salerbusinessauthority == null) {
						this.LicenseRejected[2].flag = false
					} else {
						this.LicenseRejected[2].flag = true
					}
					if (data.commitmentletter == null) {
						this.LicenseRejected[3].flag = false
					} else {
						this.LicenseRejected[3].flag = true
					}
					if (data.affiliatestatement == null) {
						this.LicenseRejected[4].flag = false
					} else {
						this.LicenseRejected[4].flag = true
					}
					if (data.filecontact == null) {
						this.LicenseRejected[5].flag = false
					} else {
						this.LicenseRejected[5].flag = true
					}
					this.openaccount = data.openaccount //开户许可证
					this.cusinfo = data.cusinfo //经销商信息表
					this.salerbusinessauthority = data.salerbusinessauthority //业务员授权书
					this.commitmentletter = data.commitmentletter //承诺函
					this.affiliatestatement = data.affiliatestatement //关联申明
					this.filecontact = data.filecontact //联系信息
				} else {
					this.$message.warning(message)
				}
			},
			// 驳回
			async OpenAccountReject(OAID) {
				let {
					code,
					data,
					message
				} = await OpenAccountReject({
					OAID: OAID,
					RejectReason: this.RejectReasonPic
				})
				if (code == 0) {
					this.$message.success("驳回成功")
					this.licenseGetAllLicense()
				} else {
					this.$message.warning(message)
				}
			},
			imgShowClick(URL) {
				this.showImg = true
				this.imgsrc = URL
			},
			SeeTO(par) {
				if (par.Extension == 'jpg' || par.Extension == 'png' || par.Extension == 'gif') {
					this.showImg = true
					this.imgsrc = par.FilePath
				} else {
					window.location.href = par.FilePath
				}
			},
			AllReview() {
				this.licenseVerifyLicense()
			},
			businessLicense() {
				this.licenseBHdialogVisibles = true
			},


			medicalEquipment() {
				this.permissionBHdialogVisibles = true
			},
			CLLMDFCR() {
				this.recordBHdialogVisibles = true
			},
			// 证照驳回
			LicenseRejectedClick(index) {
				this.RejectReasondialogVisibles = true
				this.RejectedIndex = index
			},
			async licenseRejectBusinessLicense() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessLicense({
					blid: this.license.BLID,
					RejectReason: this.RejectReasonLicense
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonLicense = ''
					this.licenseGetAllLicense()
					this.APPCustomerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "营业执照驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseRejectBusinessPermission() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessPermission({
					bpid: this.permission.BPID,
					RejectReason: this.RejectReasonPermission
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonPermission = ''
					this.licenseGetAllLicense()
					this.APPCustomerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "医疗器械经营许可证驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseRejectBusinessRecord() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessRecord({
					brid: this.record.BRID,
					RejectReason: this.RejectReasonRecord
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonRecord = ''
					this.licenseGetAllLicense()
					this.$parent.customerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "第二类医疗器械备案凭证驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseVerifyLicense() {
				let BLID = ''
				let BPID = ''
				let BRID = ''
				let OAIDs = [] //底部五张证照和联系信息的ID
				if (this.license) {
					BLID = this.license.BLID
				}
				if (this.permission) {
					BPID = this.permission.BPID
				}
				if (this.record) {
					BRID = this.record.BRID
				}
				if (this.openaccount) {
					OAIDs.push(this.openaccount.OAID)

				}
				if (this.salerbusinessauthority) {
					OAIDs.push(this.salerbusinessauthority.OAID)
				}
				if (this.cusinfo) {
					OAIDs.push(this.cusinfo.OAID)

				}
				if (this.commitmentletter) {
					OAIDs.push(this.commitmentletter.OAID)
				}
				if (this.affiliatestatement) {
					OAIDs.push(this.affiliatestatement.OAID)
				}
				if (this.filecontact) {
					OAIDs.push(this.filecontact.OAID)
				}
				let {
					code,
					data,
					message
				} = await LicenseVerifyLicense({
					blid: BLID,
					bpid: BPID,
					brid: BRID,
					OAIDs: OAIDs
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.licenseGetAllLicense()
					this.APPCustomerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "全部审核结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			add() {
				this.TitleEditor = '新增二级经销商申请'
				this.dialogVisibAuthorizationsAdd = true
			},
			update() {
				this.TitleEditor = '修改二级经销商申请'
				this.APPCustomerInfo("Edit")
			},
			del() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要删除的数据！(多选)")
					return
				}
				this.dialogVisibleDel = true
			},
			Submit() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要提交的数据！(多选)")
					return
				}
				this.dialogVisibleSubmit = true
			},
			cancelSubmit() {
				this.dialogVisibleSubmit = false
			},
			dialogOKSubmit() {
				this.APPCustomerSubmit()
			},
			// 下载模板接口
			async APPCustomerDownloadTemplet(type) {
				const loading = this.$loading({
					lock: true,
					text: '正在加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await APPCustomerDownloadTemplet()
				console.log(data, 'data');
				if (code == 0) {
					let filearr = [];
					data.forEach((item, index) => {
						filearr.push({
							title: item.Text,
							url: item.Value,
							flag: true
						})
					})
					this.DowloadList = filearr;
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close()
			},
			//下载模板
			Dowload(index) {
				location.href = this.DowloadList[index].url;
			},
			// 导出
			async APPCustomerExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await APPCustomerExport({
					ApplyCode: this.from.ApplyCode,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					Year: this.from.Year,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `二级经销商申请导出${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close()
			},
			// 导出
			AppExport() {
				this.APPCustomerExport()

			},
			withdraw() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要撤回的数据！(多选)")
					return
				}
				let isPromt = this.DataListOK.filter(item => item.Approver);
				if (isPromt.length) {
					this.$prompt('请输入撤回原因', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(({
						value
					}) => {
						this.APPCustomerRevoke(value);
					}).catch(() => {});
				} else {
					this.dialogVisiblewithdraw = true
				}
			},
			dialogOKwithdraw() {
				this.APPCustomerRevoke()
			},
			cancelwithdraw() {
				this.dialogVisiblewithdraw = false
			},
			// 审批通过
			async APPCustomerApproval() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerApproval({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleApproved = false
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibleApproved = false
					this.title = '审批结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Approved() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要审批通过的数据！(多选)")
					return
				}
				this.dialogVisibleApproved = true

			},
			cancelApproved() {
				this.dialogVisibleApproved = false
			},
			dialogOKApproved() {
				this.APPCustomerApproval()
			},
			Rejectapproval() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要驳回的数据！(多选)")
					return
				}
				this.dialogVisibRejectapproval = true
			},
			cancelRejectapproval() {
				this.dialogVisibRejectapproval = false
			},
			dialogOKRejectapproval() {
				this.APPCustomerReject()
			},
			// 审批流程
			async APPCustomerGetHistory() {
				// const loading = this.$loading({
				//   lock: true,
				//   text: '加载中...',
				//   spinner: 'el-icon-loading',
				//   background: 'rgba(255,255,255,0.3)'
				// });
				this.loadingTableprocess = true
				// let IDs = []
				// this.DataListOK.map((item, index) => {
				//   IDs.push(item.ID)
				// })
				let {
					code,
					message,
					data
				} = await APPCustomerGetHistory({
					ID: this.ID,
				})
				if (code == 0) {
					// this.$message.success(message)
					this.dialogVisiblesApprovalprocess = true
					this.ApprovalProcessTableData = data
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibleApproved = false
					this.title = '结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				this.loadingTableprocess = false
				// loading.close()
			},
			Approvalprocess() {
				if (!this.ID) {
					this.$message.error("请选择需要操作的数据！")
					return
				}
				this.APPCustomerGetHistory()
			},
			cancelApprovalprocess() {
				this.dialogVisiblesApprovalprocess = false
			},
			dialogOKApprovalprocess() {
				this.dialogVisiblesApprovalprocess = false
			},
			// 备案开户
			async APPCustomerDoOpenAccount() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerDoOpenAccount({
					IDs: IDs,
					OpenAccountStatus: this.FromArrOpenAccount[0].modelvalue
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibOpenAccount = false
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibOpenAccount = false
					this.title = '备案开户结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 备案开户
			OpenAccount() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要操作的数据���(多选)")
					return
				}
				this.dialogVisibOpenAccount = true
			},
			cancelOpenAccount() {
				this.dialogVisibOpenAccount = false
			},
			dialogOKOpenAccount() {
				this.APPCustomerDoOpenAccount()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.FromArrEditor[2].options = []
					this.FromArr[2].options = []

					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArrEditor[2].options.push(obj)
						this.FromArr[2].options.push(obj)
					})
				}
			},

			// 审批流状态下拉
			async HelperApprovalFlowStatus() {
				let {
					code,
					data,
					message
				} = await HelperApprovalFlowStatus({})
				if (code == 0) {
					this.FromArr[3].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[3].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			// 备案开户状态下拉
			async HelperOpenAccountStatusByBuyFromHome() {
				let {
					code,
					data,
					message
				} = await HelperOpenAccountStatusByBuyFromHome({})
				if (code == 0) {
					this.FromArrOpenAccount[0].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArrOpenAccount[0].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},

			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},

			// 导出
			Export() {

			},
			// 删除取消
			cancelDel() {
				this.dialogVisibleDel = false
			},
			// 确认删除
			dialogOKDel() {
				this.APPCustomerDelete()
			},
			showclick() {

			},
			hide() {

			},
			select() {
				this.pageIndex = 1
				this.from.ApplyCode = this.FromArr[1].modelvalue
				this.from.CusName = this.FromArr[0].modelvalue
				this.from.InvClass = this.FromArr[2].modelvalue ? this.FromArr[2].modelvalue.join(',') : ''
				this.from.Status = this.FromArr[3].modelvalue
				this.from.CreateTime1 = this.FromArr[4].StartTime
				this.from.CreateTime2 = this.FromArr[4].EndTime
				this.from.LicenseStatus = this.FromArr[5].modelvalue
				if (this.userInfo && this.userInfo.IsSaler != 1) {
					this.from.MyApproval = this.$refs.QuotaBtngroup.checkeds == true ? 1 : ""
				}
				this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				this.$refs.refTableQuota.$refs.fileTableSelect.setCurrentRow();
				this.ID = ''
				this.DataListOK = []
				this.APPCustomerList()
			},
			reset() {
				this.$refs.QuotaBtngroup.checkeds = false
				this.FromArr.map((item, index) => {
					if (index == 5) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
			},

			handleSelectionChange(val) {
				this.DataListOK = val
			},
			handleSelectionChangeEditor(val) {
				this.EditorTabelData = val
			},

			onRowClick(val) {
				console.log(val);
				this.ID = val.ID
				this.cusCodeTo = val.CusCode
				this.UnVerifyLicenseCount = val.UnVerifyLicenseCount //待审核证照数量
				this.ValidLicenseCount = val.ValidLicenseCount //有效证照数量
				this.RejectLicenseCount = val.RejectLicenseCount //被驳回证照数量

				this.APPCustomerInfo("See")
			},
			rejectdonRowClick(val) {
				this.getID = val.ID
				this.detailsTitle = val.LicenseType
				if (val.LicenseType == "营业执照") {
					this.licenseGetBusinessLicense()
				}
				if (val.LicenseType == "医疗器械经营许可证") {
					this.licenseGetBusinessPermission()
				}
				if (val.LicenseType == "第二类医疗器械备案凭证") {
					this.licenseGetBusinessRecord()
				}
				if (val.LicenseType == "承诺函") {
					this.OpenAccountGetCommitmentLetter()
				}
				if (val.LicenseType == "开户许可证") {
					this.OpenAccountGetOpenAccount()
				}
				if (val.LicenseType == "经销商信息表") {
					this.OpenAccountGetCusInfo()
				}
				if (val.LicenseType == "关联申明") {
					this.OpenAccountGetAffiliateStatement()
				}
				if (val.LicenseType == "业务员授权书") {
					this.OpenAccountGetSalerBusinessAuthority()
				}
				if (val.LicenseType == "联系信息") {
					this.OpenAccountGetFileContact()
				}

			},
			onRowClickHP() {

			},
			onRowClickEditor() {

			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				this.APPCustomerList()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				this.APPCustomerList()
			},
			rejecthandleCurrentChange(pageindex) {
				this.Rejectpageindex = pageindex
				this.licenseGetRejectLicense()
			},
			rejecthandleSizeChange(paegSzie) {
				this.RejectpageSize = paegSzie
				this.licenseGetRejectLicense()
			},
			cancelAuthorizationsAdd() {
				this.dialogVisibAuthorizationsAdd = false
			},
			dialogOKAuthorizationsAdd() {
				if (this.TitleEditor == "新增二级经销商申请") {
					this.APPCustomerAdd()
				}
				if (this.TitleEditor == "修改二级经销商申请") {
					this.APPCustomerEdit()
				}
			},
			LicenseRLookcancel() {
				this.LicenseRLookdialogVisibles = false
			},
			LicenseRLookdialogOK() {
				this.LicenseRLookdialogVisibles = false
			},
			licenseBHcancel() {
				this.licenseBHdialogVisibles = false
			},
			licenseBHdialogOK() {
				this.licenseRejectBusinessLicense()
				this.licenseBHdialogVisibles = false
			},
			permissionBHcancel() {
				this.permissionBHdialogVisibles = false
			},
			permissionBHdialogOK() {
				this.licenseRejectBusinessPermission()
				this.permissionBHdialogVisibles = false
			},
			recordBHcancel() {
				this.recordBHdialogVisibles = false
			},
			recordBHdialogOK() {
				this.licenseRejectBusinessRecord()
				this.recordBHdialogVisibles = false
			},
			RejectReasoncancel() {
				this.RejectReasondialogVisibles = false
			},
			RejectReasondialogOK() {
				if (this.RejectedIndex == 0) {
					this.OpenAccountReject(this.openaccount.OAID)
				} else if (this.RejectedIndex == 1) {
					this.OpenAccountReject(this.cusinfo.OAID)
				} else if (this.RejectedIndex == 2) {
					this.OpenAccountReject(this.salerbusinessauthority.OAID)
				} else if (this.RejectedIndex == 3) {
					this.OpenAccountReject(this.commitmentletter.OAID)
				} else if (this.RejectedIndex == 4) {
					this.OpenAccountReject(this.affiliatestatement.OAID)
				} else if (this.RejectedIndex == 5) {
					this.OpenAccountReject(this.filecontact.OAID)
				}
				this.RejectReasondialogVisibles = false
			},
			rejectcancel() {
				this.rejectdialogVisibles = false
			},
			rejectdialogOK() {
				this.rejectdialogVisibles = false
			},
			async remoteMethodtows(query = '') {
				let {
					code,
					data
				} = await CustomerList({
					cusName: query
				})
				if (code == 0) {
					this.FromArrEditor[13].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode,
						}
						this.FromArrEditor[13].options.push(obj)
					})
				}
			},
			async remoteMethodBOSSCusCodes(query = '') {
				let {
					code,
					data
				} = await CustomerList({
					cusName: query
				})
				if (code == 0) {
					if (this.FromArrEditor[15]) {
						this.FromArrEditor[15].options = []
						data.data.map((item, index) => {
							let obj = {
								label: item.CusName,
								value: item.CusCode,
							}
							this.FromArrEditor[15].options.push(obj)
						})
					}
				}
			},
			authChange() {
				if (this.FromArrEditor[12].checked) {
					this.FromArrEditor[3].hidden = true;
					this.FromArrEditor[5].hidden = true;
					this.FromArrEditor[11].hidden = true;
					this.FromArrEditor[6].marginLeft = 18;
					this.FromArrEditor[7].marginLeft = 51;
					this.FromArrEditor[8].marginLeft = 52;
					this.FromArrEditor[9].marginLeft = 6;
					this.FromArrEditor[10].width = 585;
					this.FromArrEditor[10].marginLeft = 91;
					this.FromArrEditor[12].marginTop = 40;
					this.FromArrEditor[12].marginLeft = 20;
					this.FromArrEditor[13].hidden = false;
					this.FromArrEditor[13].marginTop = 36;
					this.FromArrEditor[13].marginLeft = 81;
					this.FromArrEditor[14].marginTop = 27;
					this.FromArrEditor[14].marginLeft = 106;
					if (this.FromArrEditor[15]) {
						this.FromArrEditor[15].hidden = true;
					}
					this.FromUploadSettingFile.marginLeft = 25;
					this.FromUploadSettingFile.title = "备案文件上传：";
					this.FromUploadSettingFile.marginTop = 25;
					this.FromUploadSettingFileRel.marginTop = -34;
				} else {
					this.FromArrEditor[3].hidden = false;
					this.FromArrEditor[5].hidden = false;
					this.FromArrEditor[11].hidden = false;
					this.FromArrEditor[6].marginLeft = 285;
					this.FromArrEditor[7].marginLeft = 0;
					this.FromArrEditor[8].marginLeft = 40;
					this.FromArrEditor[9].marginLeft = 68;
					this.FromArrEditor[10].width = 595;
					this.FromArrEditor[10].marginLeft = 40;
					this.FromArrEditor[12].marginTop = 20;
					this.FromArrEditor[12].marginLeft = 30;
					this.FromArrEditor[13].hidden = true;
					this.FromArrEditor[13].marginTop = 20;
					this.FromArrEditor[13].marginLeft = 57;
					if (this.FromArrEditor[15]) {
						this.FromArrEditor[15].hidden = false;
						this.FromArrEditor[15].marginTop = 20;
						this.FromArrEditor[15].marginLeft = 57;
					}
					this.FromUploadSettingFile.marginLeft = 620;
					this.FromUploadSettingFile.title = "经销商引入评估表：";
					this.FromUploadSettingFile.marginTop = -35;
					this.FromUploadSettingFileRel.marginTop = 30;
				}
			}
		},
		watch: {
			dialogVisibAuthorizationsAdd: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.FromArrEditor.forEach((item, index) => {
							let indexModelvalue = ["0", "1", "2", "3", "6", "7", "8", "9"]
							let indexCheck = ["4", "5"]
							if (!indexModelvalue.includes(index)) {
								if (item.inputtype === 'selectMultiple') {
									item.modelvalue = [];
								} else {
									item.modelvalue = '';
								}
							}
							if (!indexCheck.includes(index)) {
								item.checked = false;
							}
							this.AppCusomerData = []
						})
					}
				}
			},
			dialogVisibOpenAccount: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.FromArrOpenAccount[0].modelvalue = ''
					}
				}
			},
			dialogVisibRejectapproval: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.RejectReason = ''
					}
				}
			},
			TitleEditor: {
				handler(newVal, OldVal) {
					if (newVal == '查看') {
						this.FromArrEditor.forEach((item, index) => {
							if (index == 0 || index == 12) {
								item.disabled = true
							}
							if (index == 12) {
								item.disabled = false
							}
						})
						this.SeeDisabled = false
					} else if (newVal == '新增二级经销商申请' || newVal == '修改二级经销商申请') {
						this.FromArrEditor.forEach((item, index) => {
							if (index == 0) {
								item.disabled = true
							}
							if (index == 12) {
								item.disabled = false
							}
						})
						this.SeeDisabled = true
					}
				}
			},

			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"))
					data.CusWebMenus.forEach((item, index) => {
						if (item.NodeID == 77) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, index) => {
										if (itemes.NodeID == to.query.MenuID) {
											this.qus = itemes.Buttons
										}
									})
								}
							})
						}
					});
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == 'add') {
								this.qx.add = true
							} else if (item.NodeName == 'edit') {
								this.qx.update = true
							} else if (item.NodeName == 'delete') {
								this.qx.del = true
							} else if (item.NodeName == 'stopif') {
								this.qx.del = true
							} else if (item.NodeName == 'assignment') {
								this.qx.assignment = true
							} else if (item.NodeName == 'enabled') {
								this.qx.enabled = true
							} else if (item.NodeName == 'skip') {
								this.qx.skip = true
							} else if (item.NodeName == 'reset') {
								this.qx.reset = true
							} else if (item.NodeName == 'setting') {
								this.qx.setting = true
							} else if (item.NodeName == 'submit') {
								this.downlist.forEach((item, index) => {
									if (index == 0 || index == 1) {
										item.flag = true
									}
								})
								this.qx.submit = true
							} else if (item.NodeName == 'approval') {
								this.downlist.forEach((item, index) => {
									if (index == 2 || index == 3) {
										item.flag = true
									}
								})
								this.qx.approval = true
							} else if (item.NodeName == 'openaccount') {
								this.qx.openaccount = true
							} else if (item.NodeName == 'License') {
								this.qx.License = true
							}
						})
					}
					// 首页预警处理跳转操作
					let ApplyCode = to.query.ApplyCode
					if (ApplyCode) {
						//console.log(to, '发票TOOOOOO');
						this.FromArr[1].modelvalue = ApplyCode
						this.from.ApplyCode = ApplyCode
						//this.APPCustomerList()
						return
					}
					//this.APPCustomerList()
				},
				deep: true,
				immediate: true
			},
			rejectdialogVisibles: {
				handler(newList, oldList) {
					if (newList) {
						this.BusdetailsTableData = null
						this.RedetailsTableData = null
						this.CommitmentLetterData = null
						this.filecontactData = null
						this.openaccountData = null
						this.cusinfoData = null
						this.salerbusinessauthorityData = null
						this.affiliatestatementData = null
						this.BLdetailsTableData = null
						this.detailsTitle = ''
					}
				},
				deep: true
			}
		},
	}
</script>
<style scoped lang='less'>
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Authority {
		width: 100%;
		height: 100%;

		.TopSearch {
			margin: 1px 10px;
			width: 938px;
			height: 198px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.BottomTable {
			margin: 32px 10px;
			padding: 10px;
			width: 920px;
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.fileBottomList {
			width: 100%;
			// height: 500px;

			// border: 1px solid red;
			.fileList {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				.fileBottom {
					line-height: 32px;
					border-radius: 2px;
					border: 1px solid rgb(230, 230, 230);
					cursor: pointer;
					margin-top: 10px;
					display: inline-block;
					// margin-left: 20px;
					position: relative;
					width: 430px;
					height: 32px;
					color: rgb(0, 0, 0);
					font-size: 12px;
					background-color: rgb(250, 251, 252);

					.fileName {
						width: 350px;
						display: inline-block;
						font-size: 14px;
						margin-left: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.See {
						display: inline-block;
						font-size: 14px;
						float: right;
						margin-right: 10px;
						color: rgb(231, 29, 67);
					}
				}
			}

			.fileBLTab {
				width: 100px;
				height: 32px;
				font-size: 14px;
				line-height: 32px;
				text-align: center;
				cursor: pointer;
				display: inline-block;
				border: 1px solid #e6e6e6;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
				color: rgb(231 29 67);
				background-color: rgb(252 232 236);
			}
		}
	}

	.UploadData {
		display: inline-block;
		width: 98%;

		.lable {
			width: 130px;
			margin-top: 20px;
			font-weight: 500;
			font-size: 14px;
			color: rgb(51, 51, 51);
			height: 20px;
			display: inline-block;
		}

		.imgOrFile {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.file {
				line-height: 32px;
				border-radius: 2px;
				border: 1px solid rgb(230, 230, 230);
				cursor: pointer;
				margin-top: 10px;
				display: inline-block;
				// margin-left: 20px;
				position: relative;
				width: 517px;
				height: 32px;
				color: rgb(0, 0, 0);
				font-size: 12px;
				background-color: rgb(250, 251, 252);
				margin-left: 7px;

				.fileName {
					width: 350px;
					display: inline-block;
					font-size: 14px;
					margin-left: 20px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.Del {
					display: inline-block;
					font-size: 14px;
					float: right;
					margin-right: 10px;
					color: rgb(231, 29, 67);
				}

				.See {
					display: inline-block;
					font-size: 14px;
					float: right;
					margin-right: 10px;
					color: rgb(231, 29, 67);
				}
			}
		}
	}

	.TableBottom {
		border: 1px solid red;
	}

	.line {
		width: 960px;
		height: 1px;
		background: #e5e7ea;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: 20px;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}
</style>